export class FeatureWellItem {
    constructor(
        public title: string,
        public url: string,
        public imageUrl: string,
        public imageAlt: string,
        public buttonLabel: string
    ) {}

    public static fromData(data): FeatureWellItem {
        // TODO: change after we have camel-case
        return new FeatureWellItem(
            data.title,
            data.url,
            data.image_url,
            data.image_alt,
            data.button_label
        )
    }
}
